export const getRebookPolicy = (state) => state.rebookPolicy.rebookPolicy;
export const getRebookPolicyRebookFlow = (state) => state.rebookPolicy.rebookPolicy?.rebookEligibilityInfo.rebookFlow;
export const getRebookPolicyFetchStatus = (state) => state.rebookPolicy.fetchStatus;
